import terms from "../content/solutions-terms-2026-09-19.json";
import { useNavigate } from "react-router-dom";
import SiteNav from "../components/Layout/SiteNav";
import {
  BRAND,
  PatternTile,
  Eyebrow,
  EditorialShell,
  EditorialCard,
  SerifHeading,
  PillButton,
  useEditorialPalette,
} from "../components/editorial/EditorialPrimitives";

// This JSON is duplicated in backend/solutions/service-terms-<version>.json and
// the two must stay byte-identical: the backend writes this version into every
// purchase consent record, so drift means storing proof of a version that was
// never published. tests/launch-billing.test.cjs asserts they match.
const EFFECTIVE_DATE = terms.effectiveDate;
const VERSION = terms.version;

// One published document covers every agreement. A ?version= query string from
// an older email is ignored rather than 404ing, so those links still land here.
export default function SolutionsTerms() {
  const navigate = useNavigate();
  const palette = useEditorialPalette();

  const sections = terms.sections;

  return (
    <EditorialShell>
      <SiteNav />
      <PatternTile opacity={0.04} />

      <main
        className="relative mx-auto px-4 py-14 sm:px-6 sm:py-20 lg:px-10"
        style={{ maxWidth: 860 }}
      >
        <div className="mb-10 space-y-4 text-center">
          <div className="inline-flex">
            <Eyebrow>Muslim+ Solutions</Eyebrow>
          </div>
          <SerifHeading
            level={1}
            style={{
              fontSize: "clamp(2.25rem, 5.5vw, 4rem)",
              lineHeight: 0.98,
              letterSpacing: "-0.03em",
            }}
          >
            Service <em style={{ color: BRAND.gold, fontWeight: 400 }}>terms.</em>
          </SerifHeading>
          <p className="text-sm" style={{ color: palette.muted }}>
            Effective {EFFECTIVE_DATE} · Version {VERSION}
          </p>
        </div>

        <EditorialCard variant="ivory" className="p-6 sm:p-10">
          <div className="space-y-8">
            {sections.map((s) => (
              <div key={s.t}>
                <SerifHeading
                  level={2}
                  className="mb-3"
                  style={{ fontSize: 22, fontWeight: 500, lineHeight: 1.2 }}
                >
                  {s.t}
                </SerifHeading>
                <p
                  className="text-[15px]"
                  style={{ color: palette.ink2, lineHeight: 1.65 }}
                >
                  {s.b}
                </p>
              </div>
            ))}
          </div>

          <div
            className="mt-10 border-t pt-6 text-xs"
            style={{ borderColor: palette.hairline, color: palette.muted }}
          >
            Keep a copy of the offer and the version of these terms you accept. Contact
            support@muslimplus.org with questions.
          </div>
        </EditorialCard>

        <div className="mt-10 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
          <PillButton variant="primary" onClick={() => navigate("/solutions")}>
            Back to Solutions
          </PillButton>
          <PillButton variant="ghost" onClick={() => navigate("/policy")}>
            Privacy Policy
          </PillButton>
        </div>
      </main>
    </EditorialShell>
  );
}
